<template>
  <div class="help">
    <Header :show="true" :isShadow="false" title="短信查询" />
    <div class="content">
      <div class="detail">
        <van-field
          v-model="mobile"
          center
          clearable
          type="number"
          maxlength="11"
          placeholder="请输入手机号"
        >
          <template #button>
            <van-button size="small" type="warning" @click="query"
              >查询</van-button
            >
          </template>
        </van-field>
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="finishText"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <van-cell v-for="item in list" :key="item.couponsId">
              <div>
                发送时间：{{ item.couponsActivateTime }}，{{ item.couponsDeno }}
              </div>
            </van-cell>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCouponsInfoByMobile } from "api/onLine";

export default {
  data() {
    return {
      mobile: "",
      loading: false,
      finished: true,
      error: false,
      finishText: "",
      current: 1,
      size: 50,
      total: 0,
      list: [],
    };
  },
  methods: {
    query() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.finishText = "";
      this.list = [];
      this.current = 1;
      this.total = 0;
      this.onLoad();
    },
    onLoad() {
      getCouponsInfoByMobile(this.mobile, this.current, this.size)
        .then((res) => {
          if (res.status === 200) {
            this.total += res.data.records.length;
            for (let i = 0; i < res.data.records.length; i++) {
              this.list.push(res.data.records[i]);
            }
            this.loading = false;
            if (this.total >= res.data.total) {
              this.finished = true;
            }
            this.current++;
          } else {
            this.error = true;
          }
          if (this.list.length <= 0) {
            this.finishText = "暂无信息";
            this.loading = false;
            this.finished = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
  },
};
</script>

<style scoped lang="less">
.help {
  .content {
    margin-top: 20px;
    position: relative;
    .detail {
      position: absolute;
      top: 0;
      left: 10px;
      right: 10px;
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>